export const areArraysOfObjectsEqual = (array1 = [], array2 = [], field = 'value') => {
  if (array1?.length !== array2?.length) return false;
  return array1.every(a => array2.some(b => a[field] === b[field]));
};
